import { env } from '@mntn-dev/env'

import type { AnyRoute } from '../route.ts'
import type { Authorization } from '../types/authorization.ts'
import { eatSearchCookies } from './cookie-params.ts'

export const authorizedRoutes =
  (authorization: Authorization) => (route: AnyRoute) =>
    route.isAuthorized(authorization)

export const buildCurrentUrl = (req: Request) => {
  const base = new URL(req.url)
  const origin = env.APP_BASE_URL

  return new URL(
    `${base.pathname}${eatSearchCookies(base.search)}`,
    origin
  ).toString()
}
